import * as React from "react";
const SvgCaretDown = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12.004 6c-5.77-.002-10.492.002-10.496.006-.004.004-.008.82-.008 1.812v1.803l5.25 5.19L12 20l5.25-5.19 5.25-5.189-.002-1.809-.004-1.808Z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgCaretDown;
